<template>
  <div
    class="group relative bg-grey-10 dark:bg-dark-bg hover:bg-grey-9 dark:hover:bg-dark-surface-2 transition-colors duration-200 rounded-lg p-3"
  >
    <!-- Pin Button -->
    <button
      class="absolute z-10 p-1 rounded-full transition-all"
      :class="[
        isPinned
          ? 'bg-black text-white hover:bg-grey-2 opacity-100 -top-1 -right-1'
          : 'bg-grey-8 dark:bg-dark-border text-grey-3 dark:text-dark-ink hover:bg-grey-7 dark:hover:bg-dark-border opacity-0 group-hover:opacity-100 top-2 right-2',
      ]"
      :aria-label="isPinned ? 'Unpin app' : 'Pin app'"
      @click.prevent="handleTogglePin"
    >
      <mdicon :name="pinIcon" :size="14" />
    </button>

    <!-- App Link -->
    <a
      :href="app.url"
      class="block no-underline text-inherit"
      rel="noreferrer"
      target="_blank"
      @click="$emit('close-switcher')"
    >
      <!-- App Icon and Title -->
      <div class="text-center">
        <div class="flex justify-center mb-2">
          <AppAppIcon
            :src="app.icon"
            :alt="app.title"
            :size="12"
            shadow="md"
          />
        </div>
        <h4 class="text-sm font-medium pt-1 text-grey-1 dark:text-dark-ink truncate">
          {{ app.title }}
        </h4>
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import AppAppIcon from '../icons/AppAppIcon.vue'

const props = defineProps({
  app: {
    type: Object,
    required: true,
  },
  isPinned: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle-pin', 'close-switcher'])

const pinIcon = computed(() => {
  return props.isPinned ? 'pin' : 'pin-outline'
})

const handleTogglePin = () => {
  emit('toggle-pin', props.app.id, !props.isPinned)
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
